import VueWebsocket from './src/index';

export default {
    install(Vue, options) {
        const websocket = new VueWebsocket(options.url, options.path);
        Vue.prototype.$socket = websocket.connect();
    },
};
